"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbhaLanding = AbhaLanding;
const react_1 = __importStar(require("react"));
const styles_1 = require("./styles");
function AbhaLanding({ onClick, logo, title = 'Get your ABHA card', phoneNumberDesc = 'Phone number for ABHA communications', aadhaarDesc = 'Your Aadhaar number', phoneNumberPlaceholder = '10 digit mobile number', aadhaarPlaceholder = '**** **** ****', CTAText = 'Get ABHA', userData = { phone: '' } }) {
    const phonePattern = /^[6-9]\d{9}$/;
    const aadhaarPattern = /^[1-9]\d{11}$/;
    const [showAadhaarError, setShowAadhaarError] = (0, react_1.useState)(false);
    const [showPhoneError, setShowPhoneError] = (0, react_1.useState)(false);
    const [aadhar, setAadhaar] = (0, react_1.useState)('');
    const [aadharDisplay, setAadhaarDisplay] = (0, react_1.useState)('');
    const [phone, setPhone] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        var _a;
        setPhone((_a = userData === null || userData === void 0 ? void 0 : userData.phone) !== null && _a !== void 0 ? _a : '');
    }, [userData]);
    const onCTAClick = (e) => {
        if (aadhar.length === 12 &&
            phone.length === 10 &&
            aadhaarPattern.test(aadhar) &&
            phonePattern.test(phone)) {
            onClick(e, { phone, aadhar });
        }
        else {
            if (!aadhaarPattern.test(aadhar)) {
                setShowAadhaarError(true);
            }
            else {
                setShowAadhaarError(false);
            }
            if (!phonePattern.test(phone)) {
                setShowPhoneError(true);
            }
            else {
                setShowPhoneError(false);
            }
        }
    };
    return (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement(styles_1.HeaderWrapper, null,
            react_1.default.createElement(styles_1.SVGWrapper, null,
                react_1.default.createElement("svg", { width: "289", height: "256", viewBox: "0 0 289 256", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("g", { filter: "url(#filter0_f_663_6462)" },
                        react_1.default.createElement("path", { d: "M160.972 52.0774C-53.9325 -168.742 -97.639 -21.6791 -92.6291 79.4545C43.9074 148.128 285.779 238.796 160.972 52.0774Z", fill: "url(#paint0_linear_663_6462)", "fill-opacity": "0.2" }),
                        react_1.default.createElement("path", { d: "M160.972 52.0774C-53.9325 -168.742 -97.639 -21.6791 -92.6291 79.4545C43.9074 148.128 285.779 238.796 160.972 52.0774Z", stroke: "black", "stroke-width": "0.922222" })),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("filter", { id: "filter0_f_663_6462", x: "-185.684", y: "-155.683", width: "474.023", height: "411.311", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB" },
                            react_1.default.createElement("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
                            react_1.default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                            react_1.default.createElement("feGaussianBlur", { stdDeviation: "46.1111", result: "effect1_foregroundBlur_663_6462" })),
                        react_1.default.createElement("linearGradient", { id: "paint0_linear_663_6462", x1: "51.3275", y1: "162.944", x2: "51.3275", y2: "-63.0001", gradientUnits: "userSpaceOnUse" },
                            react_1.default.createElement("stop", { "stop-color": "#6100FF" }),
                            react_1.default.createElement("stop", { offset: "1", "stop-color": "#1A23F8" }))))),
            react_1.default.createElement(styles_1.Title, null, title),
            react_1.default.createElement(styles_1.ImageWrapper, null,
                react_1.default.createElement("img", { src: logo, width: '68px', height: '42px', alt: "Logo" }))),
        react_1.default.createElement(styles_1.FormLabel, null, aadhaarDesc),
        react_1.default.createElement(styles_1.AadhaarInput, { className: "", type: "text", placeholder: aadhaarPlaceholder, name: "aadhaarNum", onChange: (e) => {
                let pureNum = e.target.value.replace(/\D/g, '').slice(0, 12);
                let spaceSplitted = pureNum
                    .split(/(?:([\d]{4}))/g)
                    .filter((s) => s.length > 0)
                    .join(' ');
                e.target.value = spaceSplitted;
                setAadhaar(pureNum);
                setAadhaarDisplay(spaceSplitted);
                if (showAadhaarError) {
                    setShowAadhaarError(pureNum.length !== 12);
                }
            }, value: aadharDisplay }),
        showAadhaarError && react_1.default.createElement(styles_1.Error, null, "Please provide valid Aadhaar number"),
        react_1.default.createElement(styles_1.FormLabel, null, phoneNumberDesc),
        react_1.default.createElement(styles_1.InputWrapper, null,
            react_1.default.createElement(styles_1.Prefix, null, "+91 "),
            react_1.default.createElement(styles_1.PhoneInput, { className: "", type: "text", placeholder: phoneNumberPlaceholder, name: "phoneNum", onChange: (e) => {
                    let pureNum = e.target.value.replace(/\D/g, '').slice(0, 10);
                    e.target.value = pureNum;
                    setPhone(pureNum);
                    if (showPhoneError) {
                        setShowPhoneError(pureNum.length !== 10);
                    }
                }, value: phone })),
        showPhoneError && react_1.default.createElement(styles_1.Error, null, "Please provide valid phone number"),
        react_1.default.createElement(styles_1.Button, { onClick: onCTAClick }, CTAText)));
}
//# sourceMappingURL=abha-landing.js.map